export default {
  gold: 'Essential',
  diamond: 'Preferred',
  complete: 'Preferred',
  Complete: 'Preferred',
  premium: 'Preferred',
  standard: 'Essential',
  professional: 'Ultimate'
}



// WEBPACK FOOTER //
// ./src/components/pages/vipShownameTransfer.js